/** Dates as the interface shows them: the ISO day, never a locale format. */

/** The day part of an ISO timestamp or date, or an empty string. */
export function dateOnly(value: string | null | undefined): string {
  return (value ?? "").slice(0, 10);
}

/** Today as an ISO day, in UTC like every date the server keeps. */
export function today(): string {
  return new Date().toISOString().slice(0, 10);
}

/**
 * An instant, in the zone of the person reading it.
 *
 * A timestamp is one moment; where it is read decides how it is written.
 * Somebody in Arizona and somebody in New York looking at the same import
 * should each see their own clock, so this uses the browser's zone.
 *
 * A **deadline** is not one of these. A deadline is a calendar day fixed by
 * the organization's policy zone, and showing it per reader would give two
 * people two different due dates for the same obligation. Deadlines stay
 * plain dates and carry the policy's zone beside them.
 */
export function localTime(value: string | null | undefined): string {
  if (value === null || value === undefined || value === "") return "unknown";
  const at = new Date(value);
  if (Number.isNaN(at.getTime())) return "unknown";
  return new Intl.DateTimeFormat(undefined, {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  }).format(at);
}

/** The zone the reader is in, as a short name for a label. */
export function readerZone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "your own zone";
  } catch {
    return "your own zone";
  }
}
